export const getLocaleHelpCenterURL = (
  appRegion: string,
  locale: string,
): string => {
  const baseUrl = "https://support.insights.granular.ag";
  let localizedUrl = baseUrl;

  switch (appRegion) {
    case "ca":
      switch (locale.toLowerCase()) {
        case "fr-ca":
          localizedUrl = `${baseUrl}/hc/fr-ca`;
          break;
        case "en-us":
          localizedUrl = `${baseUrl}/hc/en-ca`;
          break;
      }
      break;
    case "us":
      switch (locale.toLowerCase()) {
        case "fr-ca":
          localizedUrl = `${baseUrl}/hc/fr-ca`;
          break;
        default:
          localizedUrl = baseUrl;
          break;
      }
  }

  return localizedUrl;
};
